/**
 * Textes d'interface des composants (accessibilité comprise). Français par défaut ;
 * appelez setStrings() pour traduire, par exemple :
 *   setStrings({ close: 'Close', copy: 'Copy', copied: 'Copied!' })
 */
export interface HanamiStrings {
  close: string;
  collapseSidebar: string;
  expandSidebar: string;
  closeSidebar: string;
  sidebar: string;
  notifications: string;
  dismiss: string;
  copy: string;
  copied: string;
  copyFailed: string;
  carousel: string;
  previousSlide: string;
  nextSlide: string;
  goToSlide: string;
  slideOf: string;
  pause: string;
  play: string;
  themeToLight: string;
  themeToDark: string;
  themeToAuto: string;
}

const defaults: HanamiStrings = {
  close: 'Fermer',
  collapseSidebar: 'Réduire la barre latérale',
  expandSidebar: 'Déplier la barre latérale',
  closeSidebar: 'Fermer le menu',
  sidebar: 'Navigation',
  notifications: 'Notifications',
  dismiss: 'Fermer la notification',
  copy: 'Copier',
  copied: 'Copié !',
  copyFailed: 'Copie impossible',
  carousel: 'Carrousel',
  previousSlide: 'Diapositive précédente',
  nextSlide: 'Diapositive suivante',
  goToSlide: 'Aller à la diapositive {n}',
  slideOf: '{n} sur {total}',
  pause: 'Mettre en pause le défilement',
  play: 'Reprendre le défilement',
  themeToLight: 'Passer au thème clair',
  themeToDark: 'Passer au thème sombre',
  themeToAuto: 'Suivre le thème du système',
};

const current: HanamiStrings = { ...defaults };

export function setStrings(strings: Partial<HanamiStrings>): void {
  Object.assign(current, strings);
}

export function t(key: keyof HanamiStrings, vars: Record<string, string | number> = {}): string {
  return current[key].replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? ''));
}
